<template>
  <el-dialog
    title="评分明细"
    class="dialog"
    :visible.sync="visible"
    width="50rem"
  >
    <online-review-action v-bind="$attrs" show-detail />
    <template v-slot:footer>
      <el-button type="primary" @click="() => (visible = false)">
        关闭
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import OnlineReviewAction from '@/components/online-review/review/OnlineReviewAction.vue'

/**
 * 评分明细弹窗
 */
export default {
  name: 'OnlineReviewWayItemDialog',

  components: {
    OnlineReviewAction
  },

  data() {
    return {
      visible: false
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>
